var React = require('react');

function Stash (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","stroke":"#D33917","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M4.92993 4.93018L19.0699 19.0702","stroke":"#D33917","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Stash.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Stash;

Stash.default = Stash;
